import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import {
	createOldMembers,
	getRegions,
	getRegionName,
	getRegionPresident,
	getRegionConst,
	getConstName,
	getConstBranches,
	getBranchName,
	getTitles
} from "../../../api/apiServices";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import toast, { Toaster } from 'react-hot-toast'
import { format, sub } from "date-fns";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import UserRoles from '../../../hooks/userRoles';
import useAuth from "../../../hooks/useAuth";
import jwt_decode from "jwt-decode";

const minDate = sub(new Date(), {
	months: 216
});

const outsideRegions = ['US', 'UK', 'CH', 'GM'];

const CaptureOldMembers = () => {
	const { auth } = useAuth();
	const decoded = auth?.accessToken
		? jwt_decode(auth.accessToken)
		: undefined

	const role = decoded?.UserInfo?.role || ""

	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	}, []);
	let curr = new Date();
	curr.setDate(curr.getDate());
	let date = curr.toISOString().substring(0, 10);

	const [isOutsideRegion, setIsOutsideRegion] = useState(false);
	const params = useParams();
	const id = parseInt(params.id)
	const [regions, setRegions] = useState([]);
	const [constituencies, setConstituencies] = useState([]);
	const [branches, setBranches] = useState([]);
	const [titles, setTitles] = useState([]);

	const [ndcMember, setNDCMember] = useState(false);
	const [ndc_membership_number, setNDCNumber] = useState("");
	const [voter_id_number, setVoterID] = useState("");
	const [registered_ndc_member, setRegisteredNdcMember] = useState("");
	const [title, setTitle] = useState("");
	const [last_name, setLastName] = useState("");
	const [first_name, setFirstName] = useState("");
	const [middle_name, setMiddleName] = useState("");

	const [date_of_birth, setDOB] = useState(date);
	const [mobile_number, setMobile] = useState("");
	const [email, setEmail] = useState("");

	const [gender, setGender] = useState("");
	const [marital_status, setMaritalStatus] = useState("");

	const [region_code, setRegionCode] = useState("");
	const [region, setRegion] = useState("");

	const [regional_president_fullname, setRegionalPresidentFullname] = useState("");
	const [regional_president_email, setRegionalPresidentEmail] = useState("");
	const [regional_president_mobile_number, setRegionalPresidentMobileNumber] = useState("");

	const [constituency_code, setConstituencyCode] = useState("");
	const [constituency, setConstituency] = useState("");
	const [branch_code, setBranchCode] = useState("");
	const [branch, setBranch] = useState("");

	const [last_tertiary_institution, setLastInstitution] = useState("");
	const [qualification_type, setQualificationType] = useState("");
	const [qualification, setQualification] = useState("");
	const [profession, setProfesiion] = useState("");
	const [occupations, setOccupations] = useState("");
	const [employment_type, setEmploymentType] = useState("");
	const [current_employment, setCurrentEmployment] = useState("");
	const [recommended_by, setRecommendedBy] = useState("");
	const [selectedImage, setSelectedImage] = useState("");

	useEffect(() => {
		getRegions().then(setRegions);
		getTitles().then(setTitles)
	}, [id])


	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";


	const handleDOB = (e) => {
		const minDate = sub(new Date(), {
			months: 216
		});
		const dateFormat = "yyyy-MM-dd";
		const dateOfBirth = e.target.value;
		const memDOB = new Date(e.target.value);
		const today = new Date();
		const distance = today.getTime() - memDOB.getTime();
		const daysOld = Math.floor(distance / (1000 * 60 * 60 * 24));
		const memAge = Number((daysOld / 365).toFixed(0));
		if (memAge < 18) {
			toast.error(`The acceptable date of birth limit is ${format(
				minDate,
				dateFormat
			)} and below`);
			setDOB(dateOfBirth)
			return false;
		}
		setDOB(dateOfBirth)
		return true;
	}

	const handleOptionChange = (e) => {
		setQualificationType(e.target.value)
	}

	const handleLastname = (e) => {
		const lastName = e.target.value.replace(/[^A-Za-z-" "]/gi, '');
		setLastName(lastName)
	}
	const handleFirstname = (e) => {
		const firstName = e.target.value.replace(/[^A-Za-z-" "]/gi, '');
		setFirstName(firstName)
	}
	const handleMiddleName = (e) => {
		const middleName = e.target.value.replace(/[^A-Za-z-" "]/gi, '');
		setMiddleName(middleName)
	}

	const handleEmail = (e) => {
		const emailValue = e.target.value
		let emailFormat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|([0-9]{10})+$/;
		if (emailValue === "") {
			toast.error("  Please enter your email address");
		}
		else if (!emailFormat.test(emailValue)) {
			toast.error("The email address is not valid. Please provide a valid email address  to continue");
			return false;
		}
		else {
			return true;
		}
	}

	const handleNDCCheck = (e) => {
		setRegisteredNdcMember(null)
		const memCheck = e.target.value
		if (memCheck === "YES") {
			setNDCMember(true)
		} else {
			setNDCMember(false)
		}
		setRegisteredNdcMember(memCheck)
	}

	const handleRegion = (e) => {
		const regCode = e.target.value
		if (outsideRegions.includes(regCode)) {
			setIsOutsideRegion(true)
			setRegionCode(regCode);
			getRegionName(regCode).then((res) => { setRegion(res) });
			getRegionConst(regCode).then((res) => { setConstituencies(res) });
			getRegionPresident(regCode).then((res) => {
				setRegionalPresidentFullname(res.fullname)
				setRegionalPresidentEmail(res.email);
				setRegionalPresidentMobileNumber(res.mobile_number);
			});
		} else {
			setIsOutsideRegion(false)
			setRegionCode(regCode);
			getRegionName(regCode).then((res) => { setRegion(res) });
			getRegionConst(regCode).then((res) => { setConstituencies(res) });
			getRegionPresident(regCode).then((res) => {
				setRegionalPresidentFullname(res.fullname)
				setRegionalPresidentEmail(res.email);
				setRegionalPresidentMobileNumber(res.mobile_number);
			});
		}
	}

	const handleConstituency = (e) => {
		const constCode = e.target.value
		setConstituencyCode(constCode)
		getConstName(constCode).then((res) => { setConstituency(res) })
		getConstBranches(constCode).then((res) => {
			setBranches(res)
		})
	}

	const handleBranch = (e) => {
		const branchCode = e.target.value
		setBranchCode(branchCode)
		getBranchName(branchCode).then((res) => { setBranch(res) })
	}

	const maxSelectedImage = (e) => {
		let file = e.target.files[0];
		if (file.length > 1) {
			const msg = 'Only 1 images can be uploaded at a time';
			e.target.value = null; // discard selected file
			toast.error(msg)
			return false;
		} else {
			return true;
		}
	}

	const checkMimeType = (e) => {
		// get file object
		let file = e.target.files[0];
		let err = [];
		const types = ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/svc"]
		for (var i = 0; i < file.length; i++) {
			// eslint-disable-next-line
			if (types.every(type => file[i].type !== type)) {
				err[i] = file[i].type + ' is not a supported format\n';
			};
		};
		for (var x = 0; x < err.length; x++) {
			e.target.value = null;
			toast.error(err[x])
		}
		return true;
	}
	const checkFileSize = (e) => {
		let file = e.target.files[0];
		let size = 2000000;
		let err = [];
		for (var i = 0; i < file.length; i++) {
			if (file[i].size > size) {
				err[i] = file[i].type + ' is too large. Please pick a small image\n';
			};
		};
		for (var x = 0; x < err.length; x++) {
			e.target.value = null;
			toast.error(err[x])
		}
		return true;
	}

	const handleFileChange = (e) => {
		let file = e.target.files[0];
		if (file) {
			if (maxSelectedImage(e) && checkMimeType(e) && checkFileSize(e)) {
				setSelectedImage(file)
			}
		}
	};

	const handleConfirm = (e) => {
		e.preventDefault();

		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='confirm-application'>
						<h1 className='confirm-heading'>Confirm Application</h1>
						<table className="table table-borderless">
							<tbody>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>NDC Number</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{ndc_membership_number.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Date of Birth</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{date_of_birth}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>VoterID Number</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{voter_id_number}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Gender</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{gender.toUpperCase()}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Title</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{title.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Marital setMaritalStatus</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{marital_status.toUpperCase()}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>FirstName</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{first_name.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Mobile Number</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{mobile_number}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>LastName</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{last_name.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email Address</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{email}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>MiddleName</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{middle_name.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Tertiary Institution</td>
									<td colSpan="3" style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{last_tertiary_institution.toUpperCase()}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Region</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{region.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Qualification Type</td>
									<td colSpan="3" style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{qualification_type.toUpperCase()}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Constituency</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{constituency.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Qualification</td>
									<td colSpan="3" style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{qualification.toUpperCase()}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Branch</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{branch.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Profession</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{profession.toUpperCase()}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Employment Type</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{employment_type.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Occupations</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{occupations.toUpperCase()}</td>
								</tr>
								<tr>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Current Employment</td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{current_employment.toUpperCase()}</td>
									<td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}></td>
									<td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}></td>
								</tr>
								<tr>
									<td colSpan="6" style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>
										<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
											<button className="btn btn-danger" onClick={onClose}> Cancel</button>
											&nbsp;&nbsp;&nbsp;&nbsp;
											<button
												onClick={() => { handleSubmit(); onClose(); }} className="btn btn-success">
												Confirm
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				);
			}
		});
	}

	const handleSubmit = async () => {

		const minDate = sub(new Date(), {
			months: 216
		});
		const dateFormat = "yyyy-MM-dd";
		const dateOfBirth = date_of_birth;
		const memDOB = new Date(dateOfBirth);
		const today = new Date();
		const distance = today.getTime() - memDOB.getTime();
		const daysOld = Math.floor(distance / (1000 * 60 * 60 * 24));
		const memAge = Number((daysOld / 365).toFixed(0));

		if (memAge < 18) {
			toast.error(`The acceptable date of birth limit is ${format(
				minDate,
				dateFormat
			)} and below`);
			return false;
		}

		let formData = new FormData();
		formData.append('file', selectedImage)
		formData.set("registered_ndc_member", registered_ndc_member);
		formData.set("ndc_membership_number", ndc_membership_number);
		formData.set("voter_id_number", voter_id_number);
		formData.set("title", title);
		formData.set("last_name", last_name);
		formData.set("first_name", first_name);
		formData.set("middle_name", middle_name);
		formData.set("date_of_birth", date_of_birth);
		formData.set("gender", gender);
		formData.set("marital_status", marital_status);
		formData.set("mobile_number", mobile_number);
		formData.set("email", email);
		formData.set("region_code", region_code);
		formData.set("region", region);
		formData.set("constituency_code", constituency_code);
		formData.set("constituency", constituency);
		formData.set("branch_code", branch_code);
		formData.set("branch", branch);
		formData.set("last_tertiary_institution", last_tertiary_institution);
		formData.set("qualification_type", qualification_type);
		formData.set("qualification", qualification);
		formData.set("profession", profession);
		formData.set("occupations", occupations);
		formData.set("employment_type", employment_type);
		formData.set("current_employment", current_employment);
		formData.set("regional_president_email", regional_president_email);
		formData.set("recommended_by", recommended_by);

		createOldMembers(formData).then(res => {
			if (res.status === false) {
				toast.error(res.message, {
					duration: 5000,
					className: "toast-message",
				});
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
			}
			setNDCMember(false);
			setNDCNumber("");
			setVoterID("");
			setRegisteredNdcMember(null);
			setTitle("");
			setLastName("");
			setFirstName("");
			setMiddleName("");
			setDOB("");
			setMobile("");
			setEmail("");
			setGender("");
			setMaritalStatus("");
			setRegionCode("");
			setRegion("");
			setConstituencyCode("");
			setConstituency("");
			setBranchCode("");
			setBranch("");
			setRegionalPresidentFullname("");
			setRegionalPresidentEmail("");
			setRegionalPresidentMobileNumber("");
			setLastInstitution("");
			setQualificationType("");
			setQualification("");
			setProfesiion("");
			setOccupations("");
			setEmploymentType("");
			setCurrentEmployment("");
			setRecommendedBy("");
			setSelectedImage(null);
		})
		// navigate(from, { replace: true });
	}
	const handleCancel = () => {
		navigate(from, { replace: true });
	}

	const applicationForm = role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin ?
		(
			<>
				<form onSubmit={handleConfirm}  >
					<legend >NDC Membership</legend>
					<div className="form-group row">
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="fullname" className="col-sm-3 col-form-label">NDC Member ?</label>
								<div className="col-sm-5">
									<select
										type="text"
										id="registered_ndc_member"
										autoComplete="off"
										onChange={handleNDCCheck}
										required
										style={{ textTransform: "uppercase" }}
										value={registered_ndc_member}
										name="gender"
										className='form-control'
									>
										<option value="Select Option">Select Option</option>
										<option value="NO">NO</option>
										<option value='YES'>YES</option>
									</select>
								</div>
							</div>
							{ndcMember ? (
								<>
									<div className="form-group row">
										<label htmlFor="ndc_number" className="col-sm-3 col-form-label">Membership ID<span>*</span></label>
										<div className="col-sm-5">
											<input
												type="text"
												required
												style={{ textTransform: "uppercase" }}
												onChange={(e) => setNDCNumber(e.target.value)}
												value={ndc_membership_number}
												className='form-control'
											/>
										</div>
									</div>
									<div className="form-group row">
										<label htmlFor="voter_id_number" className="col-sm-3 col-form-label">Voter ID</label>
										<div className="col-sm-5">
											<input
												type="text"
												id='voter_id_number'
												name='voter_id_number'
												style={{ textTransform: "uppercase" }}
												onChange={(e) => setVoterID(e.target.value)}
												value={voter_id_number}
												className='form-control'
											/>
										</div>
									</div>
								</>
							) : (
								<div className="form-group row">
									<label htmlFor="voter_id_number" className="col-sm-3 col-form-label">Voter ID</label>
									<div className="col-sm-5">
										<input
											type="text"
											id='voter_id_number'
											name='voter_id_number'
											style={{ textTransform: "uppercase" }}
											onChange={(e) => setVoterID(e.target.value)}
											value={voter_id_number}
											className='form-control'
										/>
									</div>
								</div>
							)}
						</fieldset>
					</div>
					<fieldset>
						<legend >Personal Information</legend>
					</fieldset>
					<div className="form-group row">
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="title" className="col-sm-3 col-form-label">Title<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-5">
									<select
										type="text"
										id="title"
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setTitle(e.target.value)}
										value={title}
										required
										name="title"
										className='form-control'
									>
										<option value="">Select Option</option>
										{titles.map((item, index) =>
											<option value={item.title} key={index}>
												{item.title}
											</option>
										)}
									</select>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="last_name" className="col-sm-3 col-form-label">Last Name<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="text"
										id="last_name"
										autoComplete="off"
										onChange={handleLastname}
										value={last_name}
										required
										style={{ textTransform: "uppercase" }}
										name="last_name"
										className='form-control'
									/>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="first_name" className="col-sm-3 col-form-label">First Name<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="text"
										id="first_name"
										autoComplete="off"
										onChange={handleFirstname}
										value={first_name}
										required
										style={{ textTransform: "uppercase" }}
										name="first_name"
										className='form-control'
									/>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="middle_name" className="col-sm-3 col-form-label">Middle Name</label>
								<div className="col-sm-9">
									<input
										type="text"
										id="middle_name"
										autoComplete="off"
										onChange={handleMiddleName}
										value={middle_name}
										style={{ textTransform: "uppercase" }}
										name="middle_name"
										className='form-control'
									/>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="date_of_birth" className="col-sm-3 col-form-label">Date of Birth<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="date"
										id="date_of_birth"
										autoComplete="off"
										onChange={(e) => setDOB(e.target.value)}
										onBlur={handleDOB}
										required
										value={date_of_birth}
										name="date_of_birth"
										className='form-control'
									/>
								</div>
							</div>
						</fieldset>
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="gender" className="col-sm-3 col-form-label">Gender<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-4">
									<select
										type="text"
										id="gender"
										placeholder='Gender'
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setGender(e.target.value)}
										required
										value={gender}
										name="gender"
										className='form-control'
									>
										<option value="">Select Option</option>
										<option value="Male">Male</option>
										<option value='Female'>Female</option>
									</select>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="marital_status" className="col-sm-3 col-form-label">Marital Status<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<select
										type="text"
										id="marital_status"
										autoComplete="off"
										onChange={(e) => setMaritalStatus(e.target.value)}
										required
										value={marital_status}
										style={{ textTransform: "uppercase" }}
										name="marital_status"
										className='form-control'
									>
										<option value="">Select Option</option>
										<option value="Single">Single</option>
										<option value='Married'>Married</option>
										<option value='Divorced'>Divorced</option>
										<option value='Separated'>Separated</option>
										<option value='Widowed'>Widowed</option>
										<option value='Prefer Not to Say'>Prefer Not to Say</option>
									</select>
								</div>
							</div>
							<div className="form-group row">
								<label className="col-sm-3 col-form-label">Mobile Number<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<PhoneInput
										id="mobile_number"
										inputStyle={{ width: '100%', height: "34px" }}
										country={"gh"}
										enableSearch={true}
										value={mobile_number}
										name="mobile_number"
										onChange={(mobile_number) => setMobile(mobile_number)} />
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="email" className="col-sm-3 col-form-label">Email Address<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="email"
										id="email"
										placeholder='Email Address'
										autoComplete="off"
										onChange={(e) => setEmail(e.target.value)}
										onBlur={handleEmail}
										required
										value={email}
										name="email"
										className='form-control'
									/>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="profile_picture" className="col-sm-3 col-form-label">Profile Picture<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="file"
										name="profile_picture"
										id="profile_picture"
										autoComplete="off"
										required
										onChange={handleFileChange}
										className='form-control'
									/>
								</div>
							</div>
						</fieldset>
					</div>
					{/* REGION BEGIN */}
					<fieldset>
						<legend >Region & Constituency</legend>
					</fieldset>
					{!isOutsideRegion ?
						<div className="form-group row">
							<fieldset className="col-sm-6">
								<div className="form-group row">
									<label htmlFor="region" className="col-sm-3 col-form-label">Region<span>&nbsp;&nbsp;*</span></label>
									<div className="col-sm-9">
										<select
											type="text"
											id="region"
											autoComplete="off"
											onChange={handleRegion}
											required
											style={{ textTransform: "uppercase" }}
											value={region_code}
											name="region"
											className='form-control'
										>
											<option value="">Select Region</option>
											{regions.map((reg, index) =>
												<option value={reg.region_code} key={index}>
													{reg.region} - {reg.region_code}
												</option>
											)}
										</select>
									</div>
								</div>
								<div className="form-group row">
									<label htmlFor="constituency" className="col-sm-3 col-form-label">Constituency<span>&nbsp;&nbsp;*</span></label>
									<div className="col-sm-9">
										<select
											type="text"
											id="constituency"
											autoComplete="off"
											onChange={handleConstituency}
											required
											style={{ textTransform: "uppercase" }}
											value={constituency_code}
											name="constituency"
											className='form-control'
										>
											<option value="Select Constituency<">Select Constituency</option>
											{constituencies.map((consti, index) =>
												<option value={consti.constituency_code} key={index}>
													{consti.constituency} - {consti.constituency_code}
												</option>
											)}
										</select>
									</div>
								</div>
							</fieldset>

							<fieldset className="col-sm-6">
								{ndcMember ? (
									<>
										<div className="form-group row">
											<label htmlFor="branch" className="col-sm-3 col-form-label">Branch<span>&nbsp;&nbsp;*</span></label>
											<div className="col-sm-9">
												<select
													type="text"
													id="branch"
													autoComplete="off"
													style={{ textTransform: "uppercase" }}
													onChange={handleBranch}
													required
													value={branch_code}
													name="branch"
													className='form-control'
												>
													<option>Select Branch</option>
													{branches?.map((branch, index) =>
														<option value={branch.branch_code} key={index}>
															{branch.branch} - {branch.branch_code}
														</option>
													)}
												</select>
											</div>
										</div>
										<div className="form-group row">
											<label htmlFor="recommended_by" className="col-sm-3 col-form-label">Recommended By <span>&nbsp;&nbsp;*</span></label>
											<div className="col-sm-9">
												<input
													type="text"
													id="recommended_by"
													autoComplete="off"
													style={{ textTransform: "uppercase" }}
													onChange={(e) => setRecommendedBy(e.target.value)}
													value={recommended_by}
													required
													name="recommended_by"
													className='form-control'
												/>
											</div>
										</div>
									</>
								) : (
									<div className="form-group row">
										<label htmlFor="recommended_by" className="col-sm-3 col-form-label">Recommended By<span>&nbsp;&nbsp;*</span></label>
										<div className="col-sm-9">
											<input
												type="text"
												id="recommended_by"
												autoComplete="off"
												style={{ textTransform: "uppercase" }}
												onChange={(e) => setRecommendedBy(e.target.value)}
												value={recommended_by}
												required
												name="recommended_by"
												className='form-control'
											/>
										</div>
									</div>
								)}
							</fieldset>
						</div>
						:
						<div className="form-group row">
							<fieldset className="col-sm-6">
								<div className="form-group row">
									<label htmlFor="region" className="col-sm-3 col-form-label">Region<span>&nbsp;&nbsp;*</span></label>
									<div className="col-sm-9">
										<select
											type="text"
											id="region"
											autoComplete="off"
											onChange={handleRegion}
											required
											style={{ textTransform: "uppercase" }}
											value={region_code}
											name="region"
											className='form-control'
										>
											<option value="">Select Region</option>
											{regions.map((reg, index) =>
												<option value={reg.region_code} key={index}>
													{reg.region} - {reg.region_code}
												</option>
											)}
										</select>
									</div>
								</div>
								<div className="form-group row">
									<label htmlFor="recommended_by" className="col-sm-3 col-form-label">Recommended By <span>&nbsp;&nbsp;*</span></label>
									<div className="col-sm-9">
										<input
											type="text"
											id="recommended_by"
											autoComplete="off"
											style={{ textTransform: "uppercase" }}
											onChange={(e) => setRecommendedBy(e.target.value)}
											value={recommended_by}
											required
											name="recommended_by"
											className='form-control'
										/>
									</div>
								</div>
							</fieldset>
						</div>
					}
					{/* REGION END */}
					<fieldset>
						<legend >Regional President Information</legend>
					</fieldset>
					<div className="form-group row">
						<div className="col-sm-4">
							<label htmlFor="regional_president_fullname" >Regional President</label>
							<input
								type="text"
								id="regional_president_fullname"
								autoComplete="off"
								style={{ textTransform: "uppercase" }}
								value={regional_president_fullname}
								onChange={(e) => setRegionalPresidentFullname(e.target.value)}
								disabled
								name="regional_president_fullname"
								className='form-control'
							/>
						</div>
						<div className="col-sm-4">
							<label htmlFor="regional_president_mobile_number" >Mobile Number </label>

							<input
								type="number"
								id="regional_president_mobile_number"
								autoComplete="off"
								value={regional_president_mobile_number}
								disabled
								name="regional_president_mobile_number"
								onChange={(e) => setRegionalPresidentMobileNumber(e.target.value)}
								className='form-control'
							/>
						</div>
						<div className="col-sm-4">
							<label htmlFor="regional_president_email">Email Address </label>
							<input
								type="email"
								id="regional_president_email"
								autoComplete="off"
								onChange={(e) => setRegionalPresidentEmail(e.target.value)}
								value={regional_president_email}
								disabled
								name="regional_president_email"
								className='form-control'
							/>
						</div>
					</div>
					<fieldset>
						<legend >Education Background</legend>
					</fieldset>
					<div className="form-group row">
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="last_tertiary_institution" className="col-sm-3 col-form-label">Last Tertiary Institution<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="text"
										id="last_tertiary_institution"
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setLastInstitution(e.target.value)}
										value={last_tertiary_institution}
										required
										name="last_tertiary_institution"
										className='form-control'
									/>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="qualification_type" className="col-sm-3 col-form-label">Last Qualification Type<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<select
										type="text"
										id="qualification_type"
										autoComplete="off"
										onChange={(e) => setQualificationType(e.target.value)}
										required
										value={qualification_type}
										style={{ textTransform: "uppercase" }}
										name="qualification_type"
										className='form-control'
									>
										<option value="">Select Option</option>
										<option value="1st Degree">1st Degree</option>
										<option value='2nd Degree'>2nd Degree</option>
										<option value='3rd Degree'>3rd Degree</option>
										<option value='Others'>Others</option>
									</select>
								</div>
							</div>
						</fieldset>
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="qualification" className="col-sm-3 col-form-label">Qualification<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="text"
										id="qualification"
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setQualification(e.target.value)}
										value={qualification}
										required
										name="qualification"
										className='form-control'
									/>
								</div>
							</div>
						</fieldset>
					</div>
					<fieldset>
						<legend>Profession</legend>
					</fieldset>
					<div className="form-group row">
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="profession" className="col-sm-3 col-form-label">Profession<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="text"
										id="profession"
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setProfesiion(e.target.value)}
										value={profession}
										required
										name="profession"
										className='form-control'
									/>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="occupations" className="col-sm-3 col-form-label">Occupations<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="text"
										id="occupations"
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setOccupations(e.target.value)}
										value={occupations}
										required
										name="occupations"
										className='form-control'
									/>
								</div>
							</div>
						</fieldset>
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="employment_type" className="col-sm-3 col-form-label">Employment Type<span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<select
										type="text"
										id="employment_type"
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setEmploymentType(e.target.value)}
										value={employment_type}
										required
										name="employment_type"
										className='form-control'
									>
										<option value="">Select Option</option>
										<option value="Formal">Formal</option>
										<option value='Informal'>Informal</option>
									</select>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="current_employment" className="col-sm-3 col-form-label">Current Employment <span>&nbsp;&nbsp;*</span></label>
								<div className="col-sm-9">
									<input
										type="text"
										id="current_employment"
										autoComplete="off"
										style={{ textTransform: "uppercase" }}
										onChange={(e) => setCurrentEmployment(e.target.value)}
										value={current_employment}
										required
										name="current_employment"
										className='form-control'
									/>
								</div>
							</div>
						</fieldset>
					</div>
					<div className="panel-footer">
						<div className="form-group">
							<button
								type="submit"
								className="btn btn-danger " onClick={handleCancel}>
								Cancel
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<button type="submit" className="btn btn-success">
								Submit
							</button>
						</div>
					</div>
				</form >
			</>
		)
		:
		(
			<div style={{textAlign: "center"}}>
				<h3>You are not authorized to perform this function.</h3>
				<h3>Contact the System Administrator</h3 >
			</div>
		)


	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1><i className="fa-solid fa-users"></i> Capture Old Members</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>OLD MEMBERS - CAPTURING FORM</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								<div className="application-container">
									{applicationForm}
								</div>
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	)
}
export default CaptureOldMembers
